import { getDB } from '../core';
import type { DataItem } from '@/types';

export async function addDataItem(item: DataItem): Promise<void> {
  const db = await getDB();
  await db.put('data', item);
}

export async function getDataItem(id: string): Promise<DataItem | undefined> {
  const db = await getDB();
  return db.get('data', id);
}

export async function getAllDataItems(): Promise<DataItem[]> {
  const db = await getDB();
  return db.getAll('data');
}

export async function deleteDataItem(id: string): Promise<void> {
  const db = await getDB();
  await db.delete('data', id);
  
  // Clean up related links, widgets, history directly to avoid circular dependencies
  // Delete folder links
  const links = await db.getAllFromIndex('folderLinks', 'by-data', id);
  for (const link of links) await db.delete('folderLinks', link.id);
  
  // Delete widgets
  const widgets = await db.getAllFromIndex('widgets', 'by-data', id);
  for (const w of widgets) await db.delete('widgets', w.id);
  
  // Clean up history
  const allHistory = await db.getAll('history');
  for (const h of allHistory) {
    if (h.dataId === id) await db.delete('history', h.id);
  }
}

export async function updateDataItem(item: DataItem): Promise<void> {
  const db = await getDB();
  await db.put('data', { ...item, updatedAt: Date.now() });
}
